import axios from "axios";
import { updateSubscriptionStatus } from "./subscription";

export async function getUser() {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}profile-information`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (response.data.user) {
      updateSubscriptionStatus("Active");
      return response
    }
  } catch (err) {
    if (
      err.response &&
      err.response.status === 403 &&
      err.response.data.login_subscription === "Expired"
    ) {

      updateSubscriptionStatus("Expired");
      window.dispatchEvent(new Event("storage"));
      return;
    }
    console.log("Failed to fetch user data:", err);
    return null
  }
}